import styled from 'styled-components';
import moment from 'moment';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import LTVMainContent from '../../Model/Individual/StatisticsModel/LTVMainContent';

import IntroMarkdown from './IntroMarkdown';

export default function LtvRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const intro = data?.intro || '';
  const startDate = data?.startDate ? moment(data.startDate) : moment().startOf('month');
  const priceAvg = data?.priceAvg || 0;
  const durationAvg = data?.durationAvg || 0;
  const durationMembers = data?.durationMembers || [];

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <ContentWrapper>
        <LTVMainContent
          priceAvg={priceAvg}
          durationAvg={durationAvg}
          durationMembers={durationMembers}
          startDate={startDate} />
      </ContentWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: calc(100% - 60px);
  padding: 16px 20px;

  gap: 8px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
`;

